/* =========================================================
   NVQ PRODUCTKAART — uitklappende naam en kleurstalen
   Stond eerst inline in snippets/nvq-product-card.liquid, waardoor
   dezelfde code per productkaart werd herhaald (18x op een
   collectiepagina). Nu een keer, gedeeld en cachebaar.
   ========================================================= */

/* ---------- Productnaam uitklappen ----------
     Standaard staat de naam op één regel met puntjes. Op desktop klapt
     hij uit zodra de muis erover gaat, op mobiel als je op de puntjes
     tikt; scrollen klapt hem weer in. De hoogte animeert, zodat alles
     eronder rustig meeschuift. */
  if (!window.nvqCardTitleInit) {
    window.nvqCardTitleInit = true;

    var NVQ_TITLE_MS = 320;
    var nvqCanHover = window.matchMedia('(hover: hover)').matches;
    var nvqOpenTitles = [];

    function nvqTitleLink(wrap) {
      return wrap.querySelector('.nvq-product-card__title');
    }

    /* Meet hoe hoog de naam zou zijn zonder afkapping. We zetten de
       afkapping heel even uit en lezen de hoogte in dezelfde stap terug,
       dus de bezoeker ziet daar niets van.

       Belangrijk: we raken de hoogte van het vak zelf hier niet aan. Deden
       we dat wel (even op 'auto' zetten om te meten), dan sloeg de browser
       die tussenstand op en sprong het vak bij het opengaan ineens open in
       plaats van rustig uit te schuiven. */
    function nvqTitleFullHeight(wrap) {
      var link = nvqTitleLink(wrap);
      if (!link) return 0;

      link.style.display = 'block';
      link.style.webkitLineClamp = 'unset';
      var value = link.offsetHeight;
      link.style.display = '';
      link.style.webkitLineClamp = '';
      return value;
    }

    function nvqTitleRefresh(onlyNew) {
      var selector = onlyNew ? '[data-nvq-title]:not([data-nvq-title-truncated])' : '[data-nvq-title]';
      var wraps = document.querySelectorAll(selector);

      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.getAttribute('data-nvq-title-open') === 'true') return;
        var truncated = nvqTitleFullHeight(wrap) > wrap.offsetHeight + 1;
        wrap.setAttribute('data-nvq-title-truncated', truncated ? 'true' : 'false');
      });
    }

    function nvqTitleOpen(wrap) {
      if (!wrap || wrap.getAttribute('data-nvq-title-truncated') !== 'true') return;

      /* Staat hij al open, dan laten we de animatie met rust. Anders zou
         elke muisbeweging over het kaartje het uitschuiven opnieuw laten
         beginnen. Tijdens het dichtklappen staat de hoogte weer leeg, dan
         mag hij wel opnieuw opengaan. */
      if (wrap.getAttribute('data-nvq-title-open') === 'true' && wrap.style.height !== '') return;

      clearTimeout(wrap.__nvqTitleTimer);

      /* Eerst de hoogte van nu vastzetten, dan pas de afkapping loslaten en
         naar de volledige hoogte animeren. Zo heeft de browser een duidelijk
         beginpunt en schuift het vak netjes open. */
      var fullHeight = nvqTitleFullHeight(wrap);
      var token = (wrap.__nvqTitleToken || 0) + 1;
      wrap.__nvqTitleToken = token;

      wrap.style.height = wrap.offsetHeight + 'px';
      wrap.setAttribute('data-nvq-title-open', 'true');

      requestAnimationFrame(function () {
        /* Is de muis er in die ene beeldwissel alweer af gegaan, dan gaat
           het uitschuiven niet meer door. */
        if (wrap.__nvqTitleToken !== token) return;
        wrap.style.height = fullHeight + 'px';
      });

      if (nvqOpenTitles.indexOf(wrap) === -1) nvqOpenTitles.push(wrap);

      var more = wrap.querySelector('[data-nvq-title-more]');
      if (more) more.setAttribute('aria-expanded', 'true');
    }

    function nvqTitleClose(wrap) {
      if (!wrap || wrap.getAttribute('data-nvq-title-open') !== 'true') return;

      /* De naam blijft tijdens het inklappen volledig staan en wordt van
         onderaf weggeschoven. Pas als de animatie klaar is kappen we hem
         weer af, anders springt de tweede regel er ineens uit. */
      wrap.__nvqTitleToken = (wrap.__nvqTitleToken || 0) + 1;
      wrap.style.height = '';

      var index = nvqOpenTitles.indexOf(wrap);
      if (index !== -1) nvqOpenTitles.splice(index, 1);

      var more = wrap.querySelector('[data-nvq-title-more]');
      if (more) more.setAttribute('aria-expanded', 'false');

      wrap.__nvqTitleTimer = setTimeout(function () {
        wrap.removeAttribute('data-nvq-title-open');
      }, NVQ_TITLE_MS);
    }

    /* Tikken op de puntjes */
    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var more = event.target.closest('[data-nvq-title-more]');
      if (!more) return;

      event.preventDefault();
      event.stopPropagation();

      var wrap = more.closest('[data-nvq-title]');
      if (!wrap) return;

      if (wrap.getAttribute('data-nvq-title-open') === 'true') {
        nvqTitleClose(wrap);
      } else {
        nvqTitleOpen(wrap);
      }
    });

    /* Muis erover op desktop */
    if (nvqCanHover) {
      document.addEventListener('mouseover', function (event) {
        if (!event.target.closest) return;
        nvqTitleOpen(event.target.closest('[data-nvq-title]'));
      });

      document.addEventListener('mouseout', function (event) {
        if (!event.target.closest) return;
        var wrap = event.target.closest('[data-nvq-title]');
        if (!wrap) return;
        if (event.relatedTarget && wrap.contains(event.relatedTarget)) return;
        nvqTitleClose(wrap);
      });
    }

    /* Toetsenbord: dezelfde beweging bij focus */
    document.addEventListener('focusin', function (event) {
      if (!event.target.closest) return;
      nvqTitleOpen(event.target.closest('[data-nvq-title]'));
    });

    document.addEventListener('focusout', function (event) {
      if (!event.target.closest) return;
      nvqTitleClose(event.target.closest('[data-nvq-title]'));
    });

    /* Op aanraakschermen klapt scrollen of swipen alles weer in */
    if (!nvqCanHover) {
      var nvqScrollTimer = null;
      document.addEventListener(
        'scroll',
        function () {
          if (!nvqOpenTitles.length || nvqScrollTimer) return;
          nvqScrollTimer = setTimeout(function () {
            nvqScrollTimer = null;
            nvqOpenTitles.slice().forEach(nvqTitleClose);
          }, 60);
        },
        { passive: true, capture: true }
      );
    }

    var nvqResizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(nvqResizeTimer);
      nvqResizeTimer = setTimeout(function () { nvqTitleRefresh(false); }, 200);
    });

    function nvqTitleInit() {
      nvqTitleRefresh(false);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { nvqTitleRefresh(false); });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', nvqTitleInit);
    } else {
      nvqTitleInit();
    }

    /* Kaarten die later binnenkomen, zoals bij "toon meer producten" */
    if (window.MutationObserver) {
      var nvqObserverTimer = null;
      new MutationObserver(function () {
        clearTimeout(nvqObserverTimer);
        nvqObserverTimer = setTimeout(function () { nvqTitleRefresh(true); }, 150);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  /* ---------- Kleurstalen ----------
     De grote foto van het kaartje wisselt naar de foto van de aangewezen
     kleur. Twee dingen zijn hier belangrijk:

     1. De nieuwe foto wordt eerst op de achtergrond ingeladen en pas
        daarna omgewisseld. Voorheen werd de foto direct vervangen,
        waardoor je heel even de standaardfoto of een half geladen foto
        zag voordat de juiste kleur er stond.
     2. Ga je van de ene kleur meteen naar de andere, dan zetten we niet
        eerst de standaardfoto terug. Dat was precies de tussenstap die
        je zag knipperen. */
  if (!window.nvqSwatchInit) {
    window.nvqSwatchInit = true;

    var nvqSwatchCanHover = window.matchMedia('(hover: hover)').matches;

    function nvqSwatchCard(swatch) {
      return swatch.closest('[data-nvq-product-card]');
    }

    function nvqSwatchImage(card) {
      return card ? card.querySelector('.nvq-product-card__image--primary') : null;
    }

    /* Elke wissel krijgt een nummer. Komt een foto binnen die door een
       nieuwere wissel is ingehaald, dan negeren we hem. Zo kun je snel
       langs de kleuren gaan zonder dat de foto's door elkaar heen lopen. */
    function nvqSwatchTicket(image) {
      var next = (parseInt(image.getAttribute('data-nvq-swatch-ticket'), 10) || 0) + 1;
      image.setAttribute('data-nvq-swatch-ticket', next);
      return next;
    }

    /* Elke kleurfoto wordt maar één keer opgehaald en daarna onthouden.
       Wijs je dezelfde kleur nog eens aan, dan staat de foto er meteen. */
    var nvqSwatchLoaders = {};

    function nvqSwatchLoader(url) {
      if (!url) return null;
      if (nvqSwatchLoaders[url]) return nvqSwatchLoaders[url];

      var loader = new Image();
      loader.decoding = 'async';
      loader.src = url;
      nvqSwatchLoaders[url] = loader;
      return loader;
    }

    /* Zodra de muis het kaartje raakt (of je het aanraakt), halen we de
       foto's van alle kleuren alvast op de achtergrond op. Tegen de tijd
       dat je bij de kleine kleurblokjes bent, staan ze klaar en wisselt
       de grote foto direct in plaats van dat je even moet wachten. */
    function nvqSwatchPreload(card) {
      if (!card || card.__nvqSwatchPreloaded) return;

      var swatches = card.querySelectorAll('[data-nvq-swatch]');
      if (!swatches.length) return;

      card.__nvqSwatchPreloaded = true;
      Array.prototype.forEach.call(swatches, function (el) {
        nvqSwatchLoader(el.getAttribute('data-nvq-swatch-image'));
      });
    }

    function nvqSwatchShow(image, url) {
      if (!image || !url) return;

      if (!image.hasAttribute('data-nvq-default-srcset')) {
        var currentSrcset = image.getAttribute('srcset');
        if (currentSrcset) image.setAttribute('data-nvq-default-srcset', currentSrcset);
      }

      var ticket = nvqSwatchTicket(image);

      function swap() {
        if (String(image.getAttribute('data-nvq-swatch-ticket')) !== String(ticket)) return;
        image.removeAttribute('srcset');
        if (image.src !== url) image.src = url;
      }

      var loader = nvqSwatchLoader(url);

      if (loader.complete) {
        swap();
        return;
      }

      loader.addEventListener('load', swap, { once: true });
      loader.addEventListener('error', function () {}, { once: true });
    }

    function nvqSwatchReset(image) {
      if (!image) return;

      nvqSwatchTicket(image);

      var defaultSrc = image.getAttribute('data-nvq-default-src');
      var defaultSrcset = image.getAttribute('data-nvq-default-srcset');

      if (defaultSrcset) image.setAttribute('srcset', defaultSrcset);
      if (defaultSrc && image.src !== defaultSrc) image.src = defaultSrc;
    }

    /* Aantikken zet de kleur vast; nog een keer op dezelfde tikken zet
       de standaardfoto terug. */
    function nvqSwatchPick(swatch) {
      var card = nvqSwatchCard(swatch);
      if (!card) return;

      var image = nvqSwatchImage(card);
      var wasPicked = swatch.getAttribute('aria-pressed') === 'true';

      Array.prototype.forEach.call(card.querySelectorAll('[data-nvq-swatch]'), function (el) {
        el.setAttribute('aria-pressed', 'false');
      });

      if (wasPicked) {
        nvqSwatchReset(image);
        return;
      }

      swatch.setAttribute('aria-pressed', 'true');
      nvqSwatchShow(image, swatch.getAttribute('data-nvq-swatch-image'));
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var swatch = event.target.closest('[data-nvq-swatch]');
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      nvqSwatchPick(swatch);
    });

    /* Op aanraakschermen doet de eerste aanraking van een kaartje hetzelfde
       voorwerk als de muis op de computer. */
    document.addEventListener(
      'touchstart',
      function (event) {
        if (!event.target.closest) return;
        nvqSwatchPreload(event.target.closest('[data-nvq-product-card]'));
      },
      { passive: true }
    );

    /* Met de muis eroverheen is een voorbeeldje; op aanraakschermen bestaat
       dat niet en werkt alleen aantikken. */
    if (nvqSwatchCanHover) {
      document.addEventListener('mouseover', function (event) {
        if (!event.target.closest) return;

        var card = event.target.closest('[data-nvq-product-card]');
        if (!card) return;

        nvqSwatchPreload(card);

        var swatch = event.target.closest('[data-nvq-swatch]');
        if (!swatch) return;

        nvqSwatchShow(nvqSwatchImage(card), swatch.getAttribute('data-nvq-swatch-image'));
      });

      document.addEventListener('mouseout', function (event) {
        if (!event.target.closest) return;
        var swatch = event.target.closest('[data-nvq-swatch]');
        if (!swatch) return;

        var card = nvqSwatchCard(swatch);
        if (!card) return;

        /* Ga je rechtstreeks naar een andere kleur van hetzelfde kaartje,
           dan doen we niets: die kleur regelt de foto zelf. */
        if (event.relatedTarget && event.relatedTarget.closest) {
          var next = event.relatedTarget.closest('[data-nvq-swatch]');
          if (next && nvqSwatchCard(next) === card) return;
        }

        var image = nvqSwatchImage(card);
        var picked = card.querySelector('[data-nvq-swatch][aria-pressed="true"]');

        if (picked) {
          nvqSwatchShow(image, picked.getAttribute('data-nvq-swatch-image'));
        } else {
          nvqSwatchReset(image);
        }
      });
    }
  }
